/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    object, string, shape, func, arrayOf, number, bool,

} from 'prop-types';
import QueryString from 'qs';
import Grid from '@material-ui/core/Grid';
import { format } from 'date-fns';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactHTMLParser from 'react-html-parser';
import Media from 'react-media';
import CommonRadioGroup from './CommonRadioGroup';
import YotpoProductReview from '../YotpoProductReview';
import GraphqlFoodQuickViewContainer from './GraphqlFoodQuickView/GraphqlFoodQuickViewContainer';
import ProductNameRender from '../common/ProductNameRender';
import { clubComponentType } from '../common/types';
import { getBaseCode } from '../../../../../helpers/tracking/product/dataLayerProductHelpers';

const styles = (theme) => ({
    paperBody: {
        boxSizing: 'border-box',
        marginBottom: '20px',
        // Mobile
        // [theme.breakpoints.down(600)]: { // commented this because this is breaking club page on mobile.. using DesktopMobile component
        //     display: 'none',
        // },
    },
    listItem: {
        marginTop: '10px',
        marginBottom: '10px',
        paddingRight: '5px',
        alignItems: 'center',
    },
    skuLabelName: {
        color: theme.palette.common?.black,
        fontSize: theme?.typography?.pdpSkuLabel?.fontSize || 'inherit', // If there is a value, apply it. Otherwise, use inherited value.
        [theme.breakpoints.down('sm')]: {
            fontSize: '.8em',
        },
    },
    skuLabelProdId: {
        textAlign: 'center',
        fontSize: '14px',
    },
    skuLabelAmount: {
        color: theme.palette.cms?.skuLabelAmountColor,
        textAlign: 'right',
        fontSize: '14px',
        position: 'relative',
    },
    selctedSkuLabelAmount: {
        position: 'relative',
        textAlign: 'right',
    },
    formControlLabel: {
        width: '100%',
    },
    formControlRoot: {
        borderBottom: `1px solid ${theme.palette.cms?.skuBorderColor}`,
        '&:hover': {
            backgroundColor: theme.palette.cms?.skuLabelTransitionColor,
            transition: 'background .3s',
        },
        height: 'auto',
        padding: '0 10px',
        marginRight: '0',
    },
    availableToShipText: {
        fontSize: '12px',
        color: theme.palette.cms?.skuAvailableToShipTextColor,
        fontWeight: '700',
    },
    rootUpsell: {
        marginTop: '-40px',
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: theme.palette.cms?.skuUncheckedRadioColor,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: theme.palette.cms?.skuRadioHoverColor,
        },
    },
    checkedIcon: {
        backgroundColor: theme.palette.cms?.skuCheckedRadioColor,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: theme.palette.cms?.skuCheckedRadioColor,
        },
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        color: theme.palette.contentColor,
        fontWeight: '400',
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            right: '50px',
            fontSize: '.8em',
        },
        [theme.breakpoints.down('xs')]: {
            position: 'unset',
            fontSize: '1em',
            fontWeight: '600',
        },
    },

    salePrice: {
        color: theme.palette.primaryButton,
        margin: '0 0 0 10px',
        fontSize: '20px',
    },
    selectedSalePrice: {
        fontWeight: 'bold',
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '.9em',
        },
        [theme.breakpoints.down('xs')]: {
            position: 'unset',
            display: 'block',
            fontSize: '1em',
            fontWeight: '700',
        },
    },
    discountAmount: {
        color: theme.palette.cms?.skuPriceDiscountColor,
        fontWeight: 'normal',
        marginLeft: '10px',
        fontSize: '18px',
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            fontSize: '.9em',
        },
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },

    retailPrice: {
        fontSize: '20px',
        color: theme.palette.common?.black,
    },
    selectedRetailPrice: {
        fontWeight: 'bold',
        color: theme.palette.common?.black,
        fontSize: '20px',
    },
    productAvailibilityMessage: {
        textTransform: 'uppercase',
        fontSize: '11px',
        fontFamily: theme.typography.fontFamily,
        fontWeight: '700',
        color: theme.palette.productAvailibilityPDP,
        margin: '-2px 0px 0px 0px',
    },
    availabletoShip: {
        textTransform: 'uppercase',
        fontSize: '11px',
        fontFamily: theme.typography.fontFamily,
        fontWeight: '700',
        margin: '-2px 0px 0px 0px',
    },
    productHeaderWrapper: {
        display: 'block',
        padding: '5px 10px',
        // Mobile
        [theme.breakpoints.up(600)]: {
            display: 'none',
        },
    },
    titleAndPrice: {
        display: 'flex',
    },
    title: {
        flex: '4 0 0',
        color: theme.palette.black,
        margin: '0',
        fontSize: '1.25em',
        fontWeight: '500',
    },
    price: {
        flex: '1 0 0',
        textAlign: 'right',
        position: 'relative',
        fontSize: '1em',
        fontWeight: '600',
    },
    productId: {
        margin: '12px 0',
        fontSize: '1em',
        color: theme.palette.colorSecondary,
    },
    availability: {
        color: theme.palette.black,
        padding: '5px 0 10px',
        fontSize: '0.9em',
        boxSizing: 'border-box',
        textAlign: 'center',
        fontWeight: '700',
        textTransform: 'capitalize',
    },
    skuHeader: {
        color: theme.palette.white,
        textAlign: 'left',
        lineHeight: '40px',
        fontWeight: 300,
        paddingLeft: '10px',
        backgroundColor: theme.palette.colorPrimary,
    },
});

const GraphqlFoodProductSkus = ({
    classes,
    skuData,
    handleSkuChange,
    trackEvent,
    selectedSku,
    presentation_family,
    location,
    brand,
    product,
    productUrl,
    // history,
    skuMonths,
    product: { productType },
    changeClubMonth,
    changeClubLength,
    clubUpsells,
    changeClubUpsell,
    selectedClubUpsells,
    baseProductSku,
    clubProduct,
    showSkuOnMobile,
    isPassportBundleProduct,
    isPdpYotpoEnabled,
}) =>  {
    const isSkuShown = clubProduct || showSkuOnMobile;
    useEffect(() => {
        if (typeof window !== 'undefined' && typeof window.yotpo !== 'undefined') {
            window.yotpo.refreshWidgets();
        }
    }, []);
    const renderSkuPrice = (sku, clubPrice = false) => {
        const round = (value) => Number(`${Math.round(value * 10) / 10}`).toFixed(2);
        const priceNonSelected = clubPrice ? classes.clubPrice : classes.retailPrice;
        const priceSelected = clubPrice ? classes.clubPriceSelected : classes.selectedRetailPrice;
        if (sku?.prices?.[0] && sku?.prices?.[1]) {
            let productPrice = sku.prices[0].value;
            let discountedProductPrice = sku.prices[1].value;
            if (isPassportBundleProduct?.enable) {
                productPrice = (sku.prices[0].value + isPassportBundleProduct?.prices?.value).toFixed(2);
                discountedProductPrice = (sku.prices[1].value + isPassportBundleProduct?.prices?.value).toFixed(2);
            }
            return sku.prices[0].value > sku.prices[1].value
                ? (
                    <>
                        <span className={classes.crossedOutRetailPrice}>
                            ${productPrice}
                        </span>
                        <span className={selectedSku.id !== sku.id ? classes.salePrice : `${classes.salePrice} ${classes.selectedSalePrice}`}>
                            ${discountedProductPrice}
                        </span>
                        <span className={classes.discountAmount}>
                            ${round(sku.prices[0].value - sku.prices[1].value)} Off
                        </span>

                    </>
                )
                : (
                    <span className={selectedSku.id !== sku.id ? priceNonSelected : priceSelected}>
                        ${productPrice}
                    </span>

                );
        }
        return null;
    };
    // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
    const itemSku = (id) => id.match(/[^-_]*$/);

    const availabilityMessage = (sku) => {
        const deliveryMessage = product.availability?.deliveryMessage ? product.availability?.deliveryMessage : '';
        const availToShipMessage = deliveryMessage.replace('AVAILABLE FOR DELIVERY', 'AVAILABLE TO SHIP');
        const earliestShipDate = new Date(sku?.availability?.earliestShipDate);
        const currentDate = new Date();
        if (earliestShipDate > currentDate) {
            return `NEXT AVAILABLE DATE: ${format(earliestShipDate, 'LLL do yyyy')}`;
        }
        if (deliveryMessage === 'AVAILABLE TO SHIP NOW') {
            return <div className={classes.availabletoShip}>{deliveryMessage}</div>;
        }
        return <div className={classes.productAvailibilityMessage}>{availToShipMessage}</div>;
    };

    const getRadioLabel = (sku) => {
        const {
            name,
            partNumber,
            shortDescription,
            image,
        } = product;

        let productName = sku.name;
        if (isPassportBundleProduct?.enable) {
            if (productName?.length < 30) {
                if (isPassportBundleProduct?.skuText) {
                    productName = `${productName} ${isPassportBundleProduct?.skuText}`;
                } else {
                    productName += 'Bundle';
                }
            }
        }
        // const round = (value) => Number(`${Math.round(value * 10) / 10}`).toFixed(2);
        return (
            <Grid container className={classes.listItem}>
                <Grid item xs={6} sm={6} lg={6}>
                    <Grid item sm={12} lg={12} className={classes.skuLabelName}>{ReactHTMLParser(productName)}</Grid>
                    <Grid item sm={12} lg={12} className={classes.availableToShipText}>
                        {availabilityMessage(sku)}
                    </Grid>
                    <Grid item>
                        {
                        // eslint-disable-next-line no-underscore-dangle
                            sku.__typename === 'Upsell'
                                ? (
                                    <GraphqlFoodQuickViewContainer
                                        classes={classes}
                                        product={product}
                                        selectedSku={sku}
                                        location={location}
                                        productUrl={productUrl}
                                        brand={brand}
                                        renderSkuPrice={renderSkuPrice}
                                    />
                                ) : null
                        }
                    </Grid>
                </Grid>
                <Grid item xs={2} sm={2} lg={2} className={classes.skuLabelProdId}>{itemSku(sku?.id)}</Grid>
                <Grid item xs={4} sm={4} lg={4}>
                    {(isPdpYotpoEnabled && selectedSku.id === sku.id)  && (
                        <Grid item sm={12} lg={12}>
                            <YotpoProductReview
                                right
                                productUrl={productUrl}
                                name={name}
                                partNumber={getBaseCode(partNumber)}
                                shortDescription={shortDescription}
                                image={image}
                            />
                        </Grid>
                    )}
                    <Grid item sm={12} lg={12} className={selectedSku.id !== sku.id ? classes.skuLabelAmount : classes.selctedSkuLabelAmount}>
                        {renderSkuPrice(sku)}
                    </Grid>
                </Grid>
            </Grid>
        );
    };
    let { partNumber } = product;
    if (typeof location !== 'undefined') {
        if (location?.search) {
            const queryStr =  QueryString.parse(location.search.replace(/^\?/, ''));
            partNumber = queryStr?.baseProductPartNumber || null;
        }
    }

    return (
        // The desktop view and tablet view are same for displaying SKUs
        <>
            <Media
                query="(min-width: 768px)"
            >
                {(matches) => (matches ? (
                    <div className={classes.paperBody}>
                        <Grid
                            container
                            direction="column"
                            justify="flex-start"
                        >
                            <CommonRadioGroup
                                classes={classes}
                                skuData={skuData}
                                handleSkuChange={handleSkuChange}
                                trackEvent={trackEvent}
                                selectedSku={selectedSku}
                                getRadioLabel={getRadioLabel}
                                presentation_family={presentation_family}
                                location={location}
                                customizedRadio // passed this parameter to use customized radios
                                product={product}
                                renderSkuPrice={renderSkuPrice}
                                productType={productType}
                                skuMonths={skuMonths}
                                changeClubMonth={changeClubMonth}
                                changeClubLength={changeClubLength}
                                clubUpsells={clubUpsells}
                                selectedClubUpsells={selectedClubUpsells}
                                changeClubUpsell={changeClubUpsell}
                                parentPartNumber={partNumber}
                                baseProductSku={baseProductSku}
                            />
                        </Grid>
                    </div>
                )
                    : isSkuShown
                    && (
                        <div className={classes.paperBody}>
                            <div className={classes.skuHeader}>
                                1. Select Your Item
                            </div>
                            <Grid
                                container
                                direction="column"
                                justify="flex-start"
                            >
                                <CommonRadioGroup
                                    classes={classes}
                                    skuData={skuData}
                                    handleSkuChange={handleSkuChange}
                                    trackEvent={trackEvent}
                                    selectedSku={selectedSku}
                                    getRadioLabel={getRadioLabel}
                                    presentation_family={presentation_family}
                                    location={location}
                                    customizedRadio // passed this parameter to use customized radios
                                    brand={brand}
                                    product={product}
                                    renderSkuPrice={renderSkuPrice}
                                    productType={productType}
                                    skuMonths={skuMonths}
                                    changeClubMonth={changeClubMonth}
                                    changeClubLength={changeClubLength}
                                    clubUpsells={clubUpsells}
                                    selectedClubUpsells={selectedClubUpsells}
                                    changeClubUpsell={changeClubUpsell}
                                    parentPartNumber={partNumber}
                                    baseProductSku={baseProductSku}
                                />
                            </Grid>
                        </div>
                    ))}
            </Media>
            {!isSkuShown
                ? (
                    <ProductNameRender
                        product={product}
                        selectedSku={selectedSku}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                    />
                )
                : null}
        </>
    );
};

GraphqlFoodProductSkus.defaultProps = {
    skuMonths: {},
    changeClubMonth: () => { },
    changeClubLength: () => { },
    clubUpsells: [],
    brand: {},
    selectedClubUpsells: null,
    changeClubUpsell: () => { },
    baseProductSku: null,
    clubProduct: false,
    showSkuOnMobile: false,
    isPassportBundleProduct: {},
    isPdpYotpoEnabled: false,
};

GraphqlFoodProductSkus.propTypes = {
    classes: object.isRequired,
    skuData: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                    __typename: string.isRequired,
                }),
            ).isRequired,
            __typename: string.isRequired,
        }),
    ).isRequired,
    handleSkuChange: func.isRequired,
    selectedSku: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }).isRequired,
    trackEvent: func.isRequired,
    productUrl: string.isRequired,
    product: shape({
        name: string.isRequired,
        partNumber: string.isRequired,
        shortDescription: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
            productDeliveryType: string.isRequired,
        }).isRequired,
    }).isRequired,
    presentation_family: string.isRequired,
    location: object.isRequired,
    brand: object,
    skuMonths: object, // dynamic month named keys
    changeClubMonth: func,
    changeClubLength: func,
    clubUpsells: clubComponentType,
    selectedClubUpsells: string,
    changeClubUpsell: func,
    baseProductSku: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                    __typename: string.isRequired,
                }),
            ).isRequired,
            __typename: string.isRequired,
        }),
    ),
    clubProduct: bool,
    showSkuOnMobile: bool,
    isPassportBundleProduct: shape({
        enable: bool,
        prices: {},
    }),
    isPdpYotpoEnabled: bool,
};
const enhance = compose(
    withStyles(styles),
    withRouter,
);

export default enhance(GraphqlFoodProductSkus);
